/* ============================================================
   Web Interest — Scroll Reveal + Global JS
   File: assets/wi-scripts.js
   HOW TO ADD: Shopify Admin → Online Store → Themes → Edit code
   → assets/ → Add new asset → paste this file
   Then add this line inside your theme.liquid <head> or before </body>:
   <script src="{{ 'wi-scripts.js' | asset_url }}" defer></script>
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Scroll reveal ──────────────────────────────────────────
  const revealEls = document.querySelectorAll('.wi-reveal');
  if (revealEls.length > 0) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // Stagger siblings by their index within the parent
          const siblings = Array.from(entry.target.parentElement.querySelectorAll('.wi-reveal'));
          const idx = siblings.indexOf(entry.target);
          setTimeout(function () {
            entry.target.classList.add('wi-visible');
          }, idx * 80);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealEls.forEach(function (el) { observer.observe(el); });
  }

});